import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  enabled?: boolean
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
  }
  start: string
  end: string
  offset: number
  timeZone: string
  getFrom?: string
}

export type CountingFacesDTO = {
  total: number
  employee: number
  unique: number
  cameraId: number
  companyId: number
  clientId: number
  faceId: number
  recognitionId: number
}

export default function useGetTotalFromCountingFaces({enabled, filter, start, end, offset, timeZone, getFrom}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_PERSONALIZED_COUNTING_FACES, filter, enabled, start, end],
    queryFn: async () => (await api.reports.getOnlyTotalsFromCountingFaces({filter, start, end, offset, timeZone, getFrom})).data.data,
  })

  return query
}
